<template lang="pug">
  div.container
    el-row
      el-col.col1(
        :class="{'errorMapa' : errors.length}"
      )
        appMapa(
          ref="mapa"
          idMapa="mapaArrecadacaoGeo",
          height="65vh",
          :mapLayersConfigs="layers"
          :featureLayerConfig="featureLayerConfig"
          :buttons="buttonsConfig"
        )

        app-resumable(
          v-if="!geom"
          ref="resumable",
          :target="urlUpload",
          :fileType="validExtensions",
          idInput="upload",
          :fileTypeErrorCallback="fileTypeErrorCallback"
          @onSuccess="onSuccess",
          @onError="onError",
          @onProgress="onProgress",
          @fileAdded="onFileAdded"
        )

</template>

<script>
import AppMapa from '@/components/AppMapa'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppResumable from '@/components/AppResumable'
import { mapActions } from 'vuex'
import layerStyles from '@/utils/layerStyles'

export default {

  components: {
    AppMapa,
    AppResumable
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    geom: {
      required: false,
      type: Object
    },

    errors: {
      required: true,
      type: Array
    }
  },

  data () {
    return {
      validExtensions: ['zip'],

      urlUpload: this.$rotas.PUBLICO.UPLOAD,

      featureLayerConfig: {
        url: process.env.URL_MAPSERVER_MUNICIPIOS,
        style: layerStyles.ESTADO,
        popup: (layer) => `${layer.feature.properties.NM_MUNICIP}`
      }
    }
  },

  computed: {
    layers () {
      if (!this.geom) return []

      const layerConfig = {
        geoJson: this.geom
      }

      return [layerConfig]
    },
    buttonsConfig () {
      return [
        {
          id: 'centralizar',
          icon: 'fa-crosshairs',
          tooltip: 'Centralizar',
          onClick: this.centerMap
        }
      ]
    }
  },

  methods: {
    ...mapActions({
      resetLoader: 'loader/resetLoader',
      setLoaderWithText: 'loader/setLoaderWithText',
      calculateIntersect: 'geo/calculoIntersectGeo'
    }),

    centerMap () {
      this.$refs.mapa.recenterView()
    },

    clean () {
      this.resetLoader()
    },

    fileTypeErrorCallback () {
      this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
        this.$messages.ARQUIVO_EXTENSION_FAIL.replace('$$', this.validExtensions.join(', ')))
    },

    async onSuccess (value, fileKey) {
      // TODO realizar requisição para realizar sobreposição com os municípios
      this.clean()
      this.setLoaderWithText({
        status: true,
        text: 'Calculando interseções'
      })

      let geom = null

      if (this.geom) {
        geom = JSON.stringify(this.geom)
      }

      try {
        const data = {
          fileKey,
          geom
        }

        const response = await this.calculateIntersect(data)

        this.resetLoader()

        this.$emit('atualizarGeorreferenciamento', response)
      } catch (error) {
        this.resetLoader()
      }
    },

    onFileAdded (file) {
      this.$refs.resumable.uploadFile()
    },

    removerGeometria () {
      this.confirmBox(this.$messages.GEOMETRIA_ALL_REMOVE_CONFIRM, this.$messages.TITULO_WARNING,
        () => {
          this.$emit('onRemoveGeometria')
        },
        () => {
          this.$refs.mapa.closePopup()
        })
    },

    onError (message) {
      this.clean()
      this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, message)
    },

    onProgress (progress) {
      this.setLoaderWithText({
        status: true,
        text: `${progress}% concluído...`
      })
    }
  }

}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.removeArrecadacaoGeo {
  position: absolute;
  top: 105px;
  background-color: white;
  padding: 8px;
  border-radius: 4px;
  cursor: pointer;
  left: 10px;
  z-index: 400;
  display: flex;
  align-content: center;
  i {
    color: black;
    font-size: 12px;
  }

  &:focus {
    outline: none;
  }
}

.errorMapa {
  border: 2px solid $error;
  border-radius: 13px;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/gat/components/Mapa.vue